import React from "react"
import "./loadingIndicator.css"

const LoadingIndicator = () => {
  return <span className="dot-pulse"></span>
}

export default LoadingIndicator
